<template>
    <div>

        <slot></slot>

        <error-response :error="error" @delete="error=null"></error-response>

        <alert ref="alert"></alert>

        <portal-target name="modal"></portal-target>
        <portal-target name="dialog"></portal-target>
        <portal-target name="error"></portal-target>

    </div>
</template>

<script>
import ErrorResponse from "./ErrorResponse";
import Alert from "./UI/Alert";

export default {
    name: "FilamentVue",

    components: {
        Alert,
        ErrorResponse,
    },

    props: ['active', 'group', 'user', 'isImpersonated', 'csrf', 'can'],

    provide() {
        return {
            admin: this.user,
            group: this.group,
            can: this.can,
        }
    },

    mounted() {
        this.$root.$on('error', (e) => {
            this.error = e;
        });

        this.$root.$on('alert', (msg) => {
            this.$refs.alert.open(msg);
        });
    },

    data: () => ({
        open: false,
        error: null,
    }),

    computed: {}
}
</script>

<style scoped>

</style>
